module.exports = __webpack_public_path__ + "static/plan-ppc.b44573a3.svg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_83f21ab6/src/assets/images/plans/plan-ppc.svg
// module id = 1203
// module chunks = 0 1 2 3